export const device = 'device';
export const userDevice = 'user-device';
